type PanelSessionLocation = {
    pathname?: string | null
    search?: string | null
}

export const panelSessionPageKey = (location?: PanelSessionLocation | null) => {
    if (!location) return null
    return `${location.pathname || '/'}${location.search || ''}`
}

export function panelSessionScrollTopForPage({
    savedScrollTop,
    savedPageKey,
    currentPageKey,
    allowScrollRestore,
}: {
    savedScrollTop?: number | null
    savedPageKey?: string | null
    currentPageKey?: string | null
    allowScrollRestore: boolean
}) {
    if (!allowScrollRestore || !savedPageKey || savedPageKey !== currentPageKey) return 0

    const normalizedScrollTop = Number(savedScrollTop)
    return Number.isFinite(normalizedScrollTop) && normalizedScrollTop > 0 ? normalizedScrollTop : 0
}
